import React from 'react'
import { Image, Transformation } from 'cloudinary-react'
import { makeStyles } from '@material-ui/core'
import { CARD_PROPORTION, CLOUDINARY_NAME } from '../../../constants'
import { createACardRootStyles } from '../../CreateACard/themeStyles'
import { getCloudinaryConsumerWithoutEmbossOverlay } from '../../../utils/cloudinaryUtils'

const CARD_PREVIEW_WIDTH = 469
const maxCardHeight = Math.round(CARD_PREVIEW_WIDTH / CARD_PROPORTION)
const useStyles = makeStyles((theme) => ({
    ...createACardRootStyles,
    cardPreviewWrapperWithInnerBorder: {
        position: 'relative',
        width: 'fit-content',
        minHeight: 'auto',
        '&::before': {
            background: 'none',
            border: '2px solid #fff',
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 6,
            left: 6,
            right: 6,
            bottom: 10,
            pointerEvents: 'none',
            borderRadius: (props) => (props.isSmallPreview ? '12px' : '23px'),
            [theme.breakpoints.up('sm')]: {
                borderWidth: (props) => (!props.isSmallPreview ? '4px' : null),
                top: '3%',
                left: '3%',
                right: '3%',
                bottom: '5%',
            },
        },
    },
    cardPreviewWrapperContainer: {
        display: 'flex',
        cursor: 'pointer',
        maxWidth: '100%',
    },
    cardPreviewWrapper: {
        position: 'relative',
        margin: '0 auto',
        '& img': {
            objectFit: 'contain',
            maxWidth: '100%',
            height: 'auto',
            // Reserve the card's space before the image loads (CLS)
            aspectRatio: `${CARD_PREVIEW_WIDTH} / ${maxCardHeight}`,
            maxHeight: '300px',
            borderRadius: (props) => (props.isSmallPreview ? '10px' : '17px'),
            boxShadow:
                '0 0px 2.1px rgba(0, 0, 0, 0.23), 0 0px 17px rgba(0, 0, 0, 0.46)',
        },
        [theme.breakpoints.up('md')]: {
            marginLeft: '0px',
        },
    },
    cardImg: {
        all: 'unset',
        display: 'block',
        // These are fixed to eliminate CLS issue

        [theme.breakpoints.up('md')]: {
            width: 342,
        },

        [theme.breakpoints.up('lg')]: {
            width: 420,
            height: 269,
        },
    },
    defaultEmbossPreview: {
        top: '72%',
    },
    embossPreview: (props) => {
        const defaultEmbossStyles = {
            position: 'absolute',
            left: '9%',
            color: 'white',
            textShadow: 'rgb(0, 0, 0) 0px 0px 2px',
        }

        if (props.isSmallPreview) {
            return {
                ...defaultEmbossStyles,
                top: '70%',
                fontSize: '47%',
            }
        }

        return {
            ...defaultEmbossStyles,
            top: '73%',
            fontSize: '75%',
            [theme.breakpoints.up(350)]: {
                fontSize: '85%',
            },
            [theme.breakpoints.up('md')]: {
                fontSize: '105%',
            },
        }
    },
}))

const BacCardPreview = ({
    cardNetwork = '',
    isVirtual = false,
    showDynamicEmboss = false,
    showInnerBorder = false,
    cloudinaryPublicId = '',
    nameOnCard = '',
    messageOnCard = '',
    onClick,
    isSmallPreview,
}) => {
    const classes = useStyles({ isSmallPreview })
    const canShowDynamicEmboss = showDynamicEmboss && !isVirtual

    return (
        <div
            className={
                showInnerBorder
                    ? `${classes.cardPreviewWrapper} ${classes.cardPreviewWrapperWithInnerBorder}`
                    : classes.cardPreviewWrapper
            }
        >
            <button onClick={onClick} className={classes.cardImg}>
                <Image
                    cloudName={CLOUDINARY_NAME}
                    publicId={cloudinaryPublicId}
                    alt="Preview of your Build-a-Card"
                    // This is the LCP element on the Build-a-Card landing page
                    fetchpriority="high"
                    width={CARD_PREVIEW_WIDTH}
                    height={maxCardHeight}
                >
                    {!isVirtual && (
                        <Transformation
                            rawTransformation={getCloudinaryConsumerWithoutEmbossOverlay(
                                cardNetwork
                            )}
                        />
                    )}
                    <Transformation
                        width={CARD_PREVIEW_WIDTH}
                        height={maxCardHeight}
                        crop="scale"
                        dpr="2.0"
                        fetchFormat="auto"
                        quality="auto"
                    />
                </Image>
                {canShowDynamicEmboss && (
                    <div className={classes.embossPreview}>
                        {nameOnCard || 'RECIPIENT NAME'}
                        <br />
                        {messageOnCard || 'CUSTOM MESSAGE'}
                    </div>
                )}
            </button>
        </div>
    )
}

export default BacCardPreview
